import { createWebHistory, createRouter } from "vue-router";
import { useAuthStore } from '@/auth'



const routes = [
    {
      path: "/",
      name: "index",
      component: () => import('@/pages/index/index.vue'),
    },
    {
      path: '/catalog/:catalogUrl',
      name: 'Catalog',
      component: () => import('@/pages/shop/shop-grid/shop-grid-left-sidebar.vue'),
    },
    // {
    //   path: "/product-detail-one",
    //   name: "Procut",
    //   component: () => import('@/pages/shop/shop-detail/product-detail-one.vue'),
    // },
    {
      path: '/product/:productSeoURL/',
      name: 'Product',
      component: () => import('@/pages/shop/shop-detail/product-detail-one.vue'),
    },
    {
      path: "/checkout",
      name: "shop checkout",
      component: () => import('@/pages/shop/shop-checkout.vue'),
    },
    {
      path: '/hotline.xml',
      name: 'Hotline',
      component: () => import('@/pages/hotline.vue'),
    },
    {
        path: "/checkout-success",
        name: "shop checkout success",
        component: () => import('@/pages/shop/shop-checkout-success.vue'),
    }, 
    {
      path: "/favorite-product",
      name: "favorite-product",
      component: () => import('@/pages/shop/favorite-product.vue'),
    },
    {
      path: "/user-account",
      name: "useraccount",
      component: () => import('@/pages/account/user-account.vue'),
    },
    {
      path: "/aboutus",
      name: "aboutus",
      component: () => import('@/pages/aboutus.vue'),
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import('@/pages/contact.vue'),
    },
    {
      path: "/career",
      name: "career",
      component: () => import('@/pages/career.vue'),
    },
    {
      path: "/blogs",
      name: "blog",
      component: () => import('@/pages/blog/blogs.vue'),
    },
    {
      path: "/blog-detail",
      name: "blogs",
      component: () => import('@/pages/blog/blog-detail.vue'),
    },
    {
        path: "/helpcenter",
        name: "helpcenter",
        component: () => import('@/pages/helpcenter/helpcenter.vue'),
    },
    {
        path: "/helpcenter-faqs",
        name: "helpcenter-faqs",
        component: () => import('@/pages/helpcenter/helpcenter-faqs.vue'),
    },
    {
        path: "/helpcenter-guides",
        name: "helpcenter-guides",
        component: () => import('@/pages/helpcenter/helpcenter-guides.vue'),
    },
    {
        path: "/helpcenter-support",
        name: "helpcenter-support",
        component: () => import('@/pages/helpcenter/helpcenter-support.vue'),
    },
    {
        path: "/login",
        name: "login",
        component: () => import('@/pages/authpages/login.vue'),
    },
    {
        path: "/signup",
        name: "signup",
        component: () => import('@/pages/authpages/signup.vue'),
    },
    {
        path: "/signup-success",
        name: "signup-success",
        component: () => import('@/pages/authpages/signup-success.vue'),
    },
    {
        path: "/forgot-password",
        name: "forgot-password",
        component: () => import('@/pages/authpages/forgot-password.vue'),
    },
    {
        path: "/lock-screen",
        name: "lock-screen",
        component: () => import('@/pages/authpages/lock-screen.vue'),
    },

    {
      path: "/terms",
      name: "terms",
      component: () => import('@/pages/utility/terms.vue'),
    },
    {
        path: "/privacy",
        name: "privacy",
        component: () => import('@/pages/utility/privacy.vue'),
    },
    {
        path: "/comingsoon",
        name: "comingsoon",
        component: () => import('@/pages/specialpages/comingsoon.vue'),
    },
    {
        path: "/maintenance",
        name: "maintenance",
        component: () => import('@/pages/specialpages/maintenance.vue'),
    },
    {
        path: "/email-order-success",
        name: "email",
        component: () => import('@/pages/email/email-order-success.vue'),
    },
    {
        path: "/email-offers",
        name: "Email Offer",
        component: () => import('@/pages/email/email-offers.vue'),
    },
    {
        path: "/email-item-review",
        name: "email review",
        component: () => import('@/pages/email/email-item-review.vue'),
    },
    {
        path: "/email-confirmation",
        name: "email confirmation",
        component: () => import('@/pages/email/email-confirmation.vue'),
    },
    {
        path: "/email-cart",
        name: "email cart",
        component: () => import('@/pages/email/email-cart.vue'),
    },
    {
        path: "/email-gift-voucher",
        name: "email-gift-voucher",
        component: () => import('@/pages/email/email-gift-voucher.vue'),
    },
    {
        path: "/email-reset-password",
        name: "email-reset-password",
        component: () => import('@/pages/email/email-reset-password.vue'),
    },
    {
        path: "/user-billing",
        name: "user-billing",
        component: () => import('@/pages/account/user-billing.vue'),
    },
    {
        path: "/user-payment",
        name: "user-payment",
        component: () => import('@/pages/account/user-payment.vue'),
    },
    {
        path: "/user-invoice",
        name: "user-invoice",
        component: () => import('@/pages/account/user-invoice.vue'),
    },
    {
        path: "/user-social",
        name: "user-social",
        component: () => import('@/pages/account/user-social.vue'),
    },
    {
        path: "/user-notification",
        name: "user-notification",
        component: () => import('@/pages/account/user-notification.vue'),
    },
    {
        path: "/user-setting",
        name: "user-setting",
        component: () => import('@/pages/account/user-setting.vue'),
    },

    {
      path: "/:catchAll(.*)",
      name: "Error",
      component: () => import('@/pages/specialpages/error.vue'),
    },
    {
      path: '/search',
      name: 'SearchResults',
      component: () => import('@/pages/SearchResults.vue'),
    },
  ];
  

  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  router.beforeEach((to, from, next) => {
        const auth = useAuthStore()

        const publicPages = [
            '/login',
            '/signup',
            '/signup-client',
            '/signup-success',
            '/forgot-password',
            '/lock-screen',
        ]

        if (!auth.token && !publicPages.includes(to.path)) {
            return next('/login')
        }

        next()
    })

export default router;